// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCczv_KNaUNA3OAYCYU2R2yUkQ7ZysRWLs",
  authDomain: "air-lorawan-webhook.firebaseapp.com",
  projectId: "air-lorawan-webhook",
  storageBucket: "air-lorawan-webhook.appspot.com",
  messagingSenderId: "955610191903",
  appId: "1:955610191903:web:13173069d5b0613a86dd2a"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
const db = getFirestore(firebaseApp);

export { firebaseApp, db };